var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-dropdown" }, [
    _c(
      "button",
      {
        staticClass: "cd-toggle",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            _vm.open = !_vm.open
          }
        }
      },
      [
        _vm._v(
          "\n    " + _vm._s(_vm.selectedLabel || _vm.placeholder) + "\n    "
        ),
        _c("span", { staticClass: "caret" })
      ]
    ),
    _vm._v(" "),
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.open,
            expression: "open"
          }
        ],
        staticClass: "cd-list"
      },
      _vm._l(_vm.options, function(opt) {
        return _c(
          "li",
          {
            key: opt.short,
            class: { selected: opt.short === _vm.value },
            on: {
              click: function($event) {
                return _vm.select(opt)
              }
            }
          },
          [_vm._v("\n      " + _vm._s(opt.name) + "\n    ")]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dd19fd2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dd19fd2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomDropdown.vue
// module id = null
// module chunks = 